import Vue from 'vue';
import Vuex from 'vuex';
import { readData, delData } from '@/utils/myutils';

Vue.use(Vuex);
// 仓库数据
const state = {
    userInfo: JSON.parse(readData('user-inf')),
    fabricData: { type: 0 },
    imgOptions: {
        height: 1200,
        width: 900
    },
    fontsLoaded: [],
    productTypes: [],
    articlesData: []
};
// 修改仓库数据的唯一手段
const mutations = {
    LOGOUT(state) {
        state.userInfo = null;
    },
    LOGIN(state) {
        state.userInfo = JSON.parse(readData('user-inf'));
    },
    SETFABRICDATA(state, data) {
        state.fabricData = data;
    },
    PUSHFONT(state, data) {
        state.fontsLoaded.push(data);
    },
    SETTYPESDATA(state, data) {
        state.productTypes = data;
    },
    SETARTICLEDATA(state, data) {
        state.articlesData = data;
    }
};
// 处理action,可以书写自己的业务逻辑,也可以异步处理
const actions = {
    logout({ commit }) {

        delData('user-inf');

        commit('LOGOUT');

        QC.Login.signOut();

    },
    login({ commit }) {

        commit('LOGIN');

    },
    setFabricData({ commit }, data) {
        commit('SETFABRICDATA', data);
    },
    setTypeData({ commit }, data) {
        commit('SETTYPESDATA', data);
    },
    pushFont({ commit }, data) {
        commit('PUSHFONT', data);
    },
    setArticleData({ commit }, data) {
        commit('SETARTICLEDATA', data);
    }
};
// 获取仓库的数据更加简便
const getters = {};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
});